module.exports = __webpack_public_path__ + "static/mentor-shivam_s-957b9fa6874993ea73544edd7a65c958.jpg";